'use client';

import { useState, useEffect } from 'react';

/**
 * Extract referral code from URL params, cookie, or localStorage.
 * The middleware captures ?ref= into a __ref_code cookie on any page,
 * so the code survives navigation between pages and new tabs.
 */
export function useReferralCode(): string | null {
  const [code, setCode] = useState<string | null>(null);

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const params = new URLSearchParams(window.location.search);
    let ref = params.get('ref');

    if (!ref) {
      const match = document.cookie.match(/(?:^|; )__ref_code=([^;]*)/);
      if (match) ref = decodeURIComponent(match[1]);
    }

    if (!ref) {
      ref = localStorage.getItem('ref_code');
    }

    if (ref) {
      setCode(ref);
      localStorage.setItem('ref_code', ref);
      if (params.has('ref')) {
        const url = new URL(window.location.href);
        url.searchParams.delete('ref');
        window.history.replaceState({}, '', url.toString());
      }
    }
  }, []);

  return code;
}
